import { IEventListener, IWindowProvider } from './event-listener.interface';

export class EventListener implements IEventListener {
  private listeners: { [id: string]: EventListenerOrEventListenerObject } = {};
  private element: HTMLElement | Window | IWindowProvider | undefined;

  constructor(element: HTMLElement | Window | IWindowProvider) {
    this.element = element;
  }

  /**
   * to register listener
   * @param eventName: event name
   * @param callback: handler function
   */
  public addListener(eventName: string, callback: EventListenerOrEventListenerObject): void {
    if (this.element) {
      this.removeListener(eventName);
      this.element.addEventListener(eventName, callback);
      this.listeners[eventName] = callback;
    }
  }

  /**
   * to remove listener
   * @param eventName: event name
   */
  public removeListener(eventName: string): void {
    if (this.element && this.listeners[eventName]) {
      this.element.removeEventListener(eventName, this.listeners[eventName]);
      delete this.listeners[eventName];
    }
  }

  /**
   * to remove all listener
   */
  public removeAllListeners(): void {
    for (const eventListener of Object.keys(this.listeners)) {
      this.removeListener(eventListener);
    }
  }
}
